var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-3 col-md-2 Day",class:{ inactive: !_vm.active, active: _vm.active }},[_c('div',{staticClass:"Day-image",on:{"click":_vm.onClick}},[_c('img',{attrs:{"src":_vm.imagePath,"alt":_vm.alt}})])])}
var staticRenderFns = []

export { render, staticRenderFns }